<template>
  <SurveyFrontEnd
    v-if="callGetFormDone && isOutTime"
    :title="surveyFrontEndWording.title"
    :content="surveyFrontEndWording.content"
    :image-src="surveyFrontEndWording.imageSrc"
  />
  <div
    v-else-if="callGetFormDone"
    class="h-100 d-flex flex-column"
    :style="{ 'background-color': bgColor }"
  >
    <template v-if="!isSuccessSSO">
      <MaskLayer>
        <b-spinner variant="success" />
      </MaskLayer>
    </template>
    <template v-else>
      <PerfectScrollbar class="flex-grow-1">
        <!-- <div class="flex-grow-1 overflow-auto"> -->
        <div
          class="container mb-4"
          style="max-width: 640px"
        >
          <SurveyHeader :image-src="formImage" />
          <h1
            class="h4"
            :style="{ color: bgFontColor }"
          >
            {{ SurveyTemplateData.formName }}
          </h1>
          <pre
            class="font-size-md"
            style="white-space:pre-line"
            :style="{ color: bgFontColor }"
            v-html="SurveyTemplateData.formDesc"
          />
          <QuestionHandler
            v-for="(Question, index) in SurveyTemplateData.formDetail"
            :ref="index"
            :key="index"
            :style="themeColor"
            :form-detail-item="Question.formDetailItem"
            :choice-limit="Question.choiceLimit"
            :question-no="Question.formDetailNo"
            :type="Question.formCategoryID"
            :title="Question.formDetailName"
            :img="Question.topicImage"
            :must="Question.must"
            :must-alert-wording="mustAlertWording"
            :must-other-alert-wording="mustOtherAlertWording"
            :place-holder="Question.placeHolder"
            :active="Question.Active"
            :form-category-value-cnt="Question.formCategoryValueCnt"
            :description="Question.description"
            @UpdateAnswer="UpdateAnswer"
          />
          <b-button
            id="submitButton"
            variant="success"
            size="lg"
            block
            class="bg-customize border-customize"
            :style="{
              '--theme-color': themeColor['--theme-color'],
              color: themeFontColor,
            }"
            :disabled="submitDisabled"
            @click="submit()"
          >
            {{ submitForm }}
          </b-button>
        </div>
        <!-- </div> -->
      </PerfectScrollbar>
      <div
        v-if="SurveyTemplateData.progressBar"
        class="bg-white shadow-custom position-sticky"
        style="bottom: 0; z-index: 100"
      >
        <div
          class="container px-lg-0 my-3 d-flex align-items-center"
          style="max-width: 640px"
        >
          <div
            class="d-flex align-items-center"
            :class="{ 'w-50': showCountDown, 'w-100': !showCountDown }"
          >
            <b-progress
              :max="max"
              show-valu0
              class="w-100 rounded-pill"
              height="8px"
            >
              <b-progress-bar
                :value="Completepercentage"
                variant
                class="bg-customize"
                :style="themeColor"
              />
            </b-progress>
            <div class="pl-3 font-size-md text-gray600">
              {{ Completepercentage }}%
            </div>
          </div>
          <div
            v-if="showCountDown"
            class="w-50 text-right font-size-md text-gray600"
          >
            <span class="mr-2">{{ formCountdown }}</span>
            <span>{{ pad(stillHaveTotalMin) }}:{{ pad(stillHaveSec) }}</span>
          </div>
        </div>
      </div>
      <MaskLayer v-if="showPreventPopup">
        <Popup
          :hide-close="true"
          :text-of-o-k="textOfOK"
          :text-of-cancel="textOfCancel"
          @confirm="realGoOut"
          @cancel="showPreventPopup = false"
        >
          <h5 class="text-break text-break-word alert-heading">
            {{ title }}
          </h5>
          <p class="text-break text-break-word font-size-md">
            {{ content }}
          </p>
        </Popup>
      </MaskLayer>
    </template>
  </div>
</template>

<script>
import '@/assets/css/te-cutsom.min.css';
import _ from 'lodash';
import QuestionHandler from '@/components/QuestionHandler.vue';
import SurveyHeader from '@/components/SurveyHeader.vue';
import PerfectScrollbar from '@/components/PerfectScrollbar.vue';
import SurveyFrontEnd from '@/components/SurveyFrontEnd.vue';
import { mapMutations, mapState, mapActions } from 'vuex';
import MaskLayer from '@/components/MaskLayer.vue';
import Popup from '@/components/Popup.vue';
import { SsoVueUrl, publicPath } from '@/config';
import SurveyService from '../service/SurveyService';
import ssoService from '../service/ssoService';

export default {
  name: 'Index',

  components: {
    QuestionHandler,
    SurveyHeader,
    PerfectScrollbar,
    SurveyFrontEnd,
    MaskLayer,
    Popup
  },
  data() {
    return {
      textOfOK: '',
      textOfCancel: '',
      title: '',
      content: '',
      // 百分比
      valuep: (this.AlreadyFillin / this.AllQustionCnt) * 100,
      max: 100,
      StartTime: '',
      EndTime: '',
      formReplyID: this.$route.query.formReplyID,
      formID: this.$route.query.formID,
      SurveyTemplateData: {},
      AnswerArray: [],
      AlreadyFillin: 0,
      AllQustionCnt: 1,
      mustAlertWording: '錯誤訊息錯誤訊息',
      mustOtherAlertWording: '錯誤訊息錯誤訊息',
      placeHolder: '',
      AlreadyFillinRelationQuestion: [],
      isAlertleave: true,
      isOutTime: false,
      callGetFormDone: false,
      isTooEarly: false,
      surveyFrontEndWording: {
        imageSrc: '',
        title: '',
        content: ''
      },
      stillHaveTotalSec: 0,
      IsMustDone: true,
      showCountDown: false,
      timer: null,
      replyed: false,
      formCountdown: '',
      submitForm: '',
      showPreventPopup: false,
      goRoute: {},
      formImage: '',
      beforeStart_Title: '',
      beforeStart_Content: '',
      beforeStart_ImageSrc: '',
      afterEnd_Title: '',
      afterEnd_Content: '',
      afterEnd_ImageSrc: '',
      ssoCode: this.$route.query.code,
      isSuccessSSO: true,
      submitDisabled: false
    };
  },
  methods: {
    ...mapMutations('form', ['setFormData']),
    ...mapMutations('formSetting', ['set']),
    ...mapActions('formSetting', ['formCompany', 'getFormLinkUrl']),
    submit() {
      const vm = this;
      const nowTimestamp = new Date().getTime();
      // 檢查時間
      vm.IsMustDone = true;
      // 檔連續點擊
      vm.submitDisabled = true;

      const RelationQuestion = vm.SurveyTemplateData.formDetail.filter((y) => !y.Active || y.formCategoryID === 'TextDescription').map((x) => x.formDetailNo);
      let firstQuestion = false;
      for (
        let index = 0;
        index < vm.SurveyTemplateData.formDetail.length;
        index += 1
      ) {
        if (
          !RelationQuestion.includes(
            vm.SurveyTemplateData.formDetail[index].formDetailNo
          )
        ) {
          const Question = vm.$refs[index][0];
          const QuestionDone = Question.Check();
          if (!QuestionDone) {
            if (!firstQuestion) {
              switch (Question.type) {
                case 'RadioButton':
                  Question.$children[0].$children[0].$children[0].focus();
                  firstQuestion = true;
                  break;
                case 'CheckBox':
                  Question.$children[0].$children[0].focus();
                  firstQuestion = true;
                  break;
                case 'Input':
                  Question.$children[0].$children[0].focus();
                  firstQuestion = true;
                  break;
                case 'TextArea':
                  Question.$children[0].$children[0].focus();
                  firstQuestion = true;
                  break;
                case 'Score':
                  Question.$children[0].$children[0].focus();
                  firstQuestion = true;
                  break;
                default:
                  break;
              }
            }
            vm.IsMustDone = false;
          }
        }
      }
      if (nowTimestamp < vm.StartTime) {
        vm.$router.replace({
          name: 'Invaild_early',
          params: { StartTime: this.StartTime, EndTime: this.EndTime }
        });
      } else if (nowTimestamp > vm.EndTime && vm.EndTime !== 0) {
        vm.$router.replace({
          name: 'Invaild',
          params: { StartTime: this.StartTime, EndTime: this.EndTime }
        });
        // 檢查必填
      } else if (vm.IsMustDone) {
        // 送出時排掉填過但被跳題的答案
        this.AnswerArray = this.AnswerArray.filter(
          (x) => vm.SurveyTemplateData.formDetail.filter((y) => y.Active).map((c) => c.formDetailNo).includes(x.formDetailNo)
        );
        const body = {
          formreplyid: this.formReplyID,
          formDetailResult: this.AnswerArray.sort(
            (a, b) => a.formDetailNo - b.formDetailNo
          )
        };
        SurveyService.putSurvayAnswer(body).then((res) => {
          if (res.success) {
            this.setFormData({ id: 'labelingInformation', value: res.data[0] });
            this.replyed = true;
            sessionStorage.removeItem('strFormReplyID');
            this.$router.replace({ name: 'result' });
          } else {
            this.$router.replace({ name: 'Error' });
          }
        });
      } else {
        // 檔連續點擊用
        vm.submitDisabled = false;
      }
    },
    // IsComplete = false 答案被清空 , IsComplete = true 有填答案
    UpdateAnswer(QuestionNo, ItemNo, Answer, IsComplete) {
      const vm = this;
      // 處理跳題 把被跳的題目的Active壓成false
      if (
        vm.SurveyTemplateData.formDetail.filter(
          (x) => x.formDetailNo === QuestionNo
        )[0].formCategoryID === 'RadioButton'
      ) {
        if (
          vm.AlreadyFillinRelationQuestion.filter(
            (x) => x.QuestionNo === QuestionNo
          ).length !== 0
        ) {
          // 先恢復原本被跳的題目 在處理跳題
          const restoreQuestion = vm.AlreadyFillinRelationQuestion.filter(
            (x) => x.QuestionNo === QuestionNo
          )[0];
          const fromRestoreQuestionNo = vm.SurveyTemplateData.formDetail.findIndex(
            (x) => x.formDetailNo === restoreQuestion.QuestionNo
          );
          const toRestoreQuestion = vm.SurveyTemplateData.formDetail
            .filter((x) => x.formDetailNo === restoreQuestion.QuestionNo)[0]
            .formDetailItem.filter((x) => x.seqno === restoreQuestion.ItemNo)[0]
            .relationFormDetail;
          for (
            let index = fromRestoreQuestionNo + 1;
            index < toRestoreQuestion - 1;
            index += 1
          ) {
            const RelationQuestionExcept = vm.AlreadyFillinRelationQuestion.filter(
              (x) => x.QuestionNo !== QuestionNo
            );
            let IsAlreadyOrderQuestionRelation = false;
            if (RelationQuestionExcept.length !== 0) {
              RelationQuestionExcept.forEach((x) => {
                if (x.RelationIndex.includes(index)) {
                  IsAlreadyOrderQuestionRelation = true;
                }
              });
            }
            if (!IsAlreadyOrderQuestionRelation) {
              vm.SurveyTemplateData.formDetail[index].Active = true;
            }
          }
        }
        const fromQuestionNo = vm.SurveyTemplateData.formDetail.findIndex(
          (x) => x.formDetailNo === QuestionNo
        );
        const toQuestionNo = vm.SurveyTemplateData.formDetail
          .filter((x) => x.formDetailNo === QuestionNo)[0]
          .formDetailItem.filter((x) => x.seqno === ItemNo[0])[0]
          .relationFormDetail;
        if (
          vm.SurveyTemplateData.formDetail
            .filter((x) => x.formDetailNo === QuestionNo)[0]
            .formDetailItem.filter((x) => x.seqno === ItemNo[0])[0].relationForm
        ) {
          // 1. 有選過更新答案 (要enable原先被跳題)
          // 2. 沒選過寫入答案
          for (
            let index = fromQuestionNo + 1;
            index < toQuestionNo - 1;
            index += 1
          ) {
            vm.SurveyTemplateData.formDetail[index].Active = false;
          }
        }
        // 若已被寫入則刪除後在加新的
        vm.AlreadyFillinRelationQuestion = vm.AlreadyFillinRelationQuestion.filter(
          (x) => x.QuestionNo !== QuestionNo
        );
        if (
          vm.SurveyTemplateData.formDetail
            .filter((x) => x.formDetailNo === QuestionNo)[0]
            .formDetailItem.filter((x) => x.seqno === ItemNo[0])[0].relationForm
        ) {
          vm.AlreadyFillinRelationQuestion.push({
            QuestionNo,
            ItemNo: ItemNo[0],
            // Renge = toQuestionNo - 1 - ( fromQuestionNo + 1 )
            RelationIndex: Array(toQuestionNo - fromQuestionNo - 2)
              .fill(0)
              .map((e, i) => i + fromQuestionNo + 1),
            RelationQuestionNo: Array(toQuestionNo - fromQuestionNo - 2)
              .fill(0)
              .map((e, i) => i + QuestionNo + 1)
          });
        }
      }
      // 寫入答案 1.刪掉就答案 2.寫入新的`
      if (this.AnswerArray.length !== 0 && this.AnswerArray.filter((x) => x.formDetailNo === QuestionNo).length
          !== 0
      ) {
        this.AnswerArray = this.AnswerArray.filter(
          (x) => x.formDetailNo !== QuestionNo
        );
      }
      if (IsComplete) {
        this.formDetailItemNoStore = [];
        if (ItemNo.length !== 0) {
          ItemNo.forEach((x) => {
            this.formDetailItemNoStore.push(
              vm.SurveyTemplateData.formDetail
                .filter((y) => y.formDetailNo === QuestionNo)[0]
                .formDetailItem.filter((y) => y.seqno === x)[0].formDetailItemNo
            );
          });
        }
        if (
          vm.SurveyTemplateData.formDetail.filter(
            (x) => x.formDetailNo === QuestionNo
          )[0].formCategoryID === 'CheckBox'
        ) {
          this.formDetailItemNoStore.forEach((x) => {
            if (
              vm.SurveyTemplateData.formDetail
                .filter((y) => y.formDetailNo === QuestionNo)[0]
                .formDetailItem.filter((y) => y.formDetailItemNo === x)[0].other
            ) {
              this.AnswerArray.push({
                formDetailNo: QuestionNo,
                formDetailItemNo: [x],
                formDetailItemMemo: Answer
              });
            } else {
              this.AnswerArray.push({
                formDetailNo: QuestionNo,
                formDetailItemNo: [x],
                formDetailItemMemo: ''
              });
            }
          });
        } else {
          this.AnswerArray.push({
            formDetailNo: QuestionNo,
            formDetailItemNo: this.formDetailItemNoStore,
            formDetailItemMemo: Answer
          });
        }
      }
      // 點了某個題目
      const FindQuestion = _.find(vm.SurveyTemplateData.formDetail, (o) => o.formDetailNo === QuestionNo);
      // 抓出某個題目的index
      const selfindex = vm.SurveyTemplateData.formDetail.map((d) => d.formDetailNo).indexOf(QuestionNo);
      const i = FindQuestion.formDetailItem[ItemNo[0] - 1].relationForm ? FindQuestion.formDetailItem[ItemNo[0] - 1].relationFormDetail - 1 : selfindex;
      // 點了某題目以下的題目都先打開
      for (let index = i; index <= (vm.SurveyTemplateData.formDetail.length - 1); index += 1) {
        vm.SurveyTemplateData.formDetail[index].Active = true;
      }
      // 在判斷已選過答案中，除了自己以下的題目中有沒有選過跳題的選項
      this.AnswerArray.sort((a, b) => a.formDetailNo - b.formDetailNo).filter((x) => x.formDetailNo > FindQuestion.formDetailNo).forEach((x) => {
        const formdata = vm.SurveyTemplateData.formDetail.filter((y) => y.formDetailNo === x.formDetailNo && y.Active);
        if (formdata.length > 0) {
          const detaildata = formdata[0].formDetailItem.filter((z) => z.formDetailItemNo === x.formDetailItemNo[0])[0];
          if (detaildata.relationForm) {
            const tempindex = vm.SurveyTemplateData.formDetail.map((d) => d.formDetailNo).indexOf(x.formDetailNo);
            // 若有跳題則跳過的題目關閉
            for (let index = tempindex + 1; index < (detaildata.relationFormDetail - 1); index += 1) {
              vm.SurveyTemplateData.formDetail[index].Active = false;
            }
          }
        }
      });

      // 重算總題數與下方完成度
      const showQ = this.SurveyTemplateData.formDetail.filter(
        (x) => x.Active === true && x.formCategoryID !== 'TextDescription'
      );
      this.AllQustionCnt = showQ.length;
      const ans = this.AnswerArray.map((z) => z.formDetailNo);
      this.AlreadyFillin = showQ.map((z) => z.formDetailNo).filter((x) => ans.indexOf(x) > -1).length;
    },
    CheckSessionStorageNull(value) {
      if (value && value !== null && value !== undefined) return true;
      return false;
    },
    checkCanReply(formInfo) {
      const timebody = {
        formID: this.formID
      };

      // 網址有則將網址的 formReplyID 存起來
      if (this.formReplyID && this.formReplyID !== 'undefined') {
        sessionStorage.strFormReplyID = this.formReplyID;
      }

      // sessionStorage 有則用 sessionStorage 的 strFormReplyID
      // 沒有則用網址的
      if (sessionStorage.strFormReplyID && sessionStorage.strFormReplyID !== 'undefined') {
        timebody.replyid = sessionStorage.strFormReplyID;
      }

      // 確認問卷是否有效
      SurveyService.getSurvayVaildTime(timebody).then((res) => {
        if (res.success) {
          this.StartTime = res.data[0].tspFormStart;
          this.EndTime = res.data[0].tspFormEnd;
          this.formReplyID = res.data[0].strFormReplyID;
          if (this.formReplyID) {
            sessionStorage.strFormReplyID = this.formReplyID;
          }
          this.getStillHaveTotalSec();

          this.timer = setInterval(() => {
            this.getStillHaveTotalSec();
          }, 200);

          if (res.data[0].tspClickTime < this.StartTime) {
            this.isTooEarly = true;
            this.isOutTime = true;
          } else if (res.data[0].tspClickTime > this.EndTime && this.EndTime !== 0) {
            this.isOutTime = true;
          }
        } else if (res.data.status === '609') {
          this.$router.replace({ name: 'result' });
          this.setFormData({ id: 'showFinishPopup', value: true });
        } else {
          this.$router.replace({ name: 'Error' });
        }
      })
        .finally(() => {
          if (this.isOutTime && this.isTooEarly) {
            this.surveyFrontEndWording.imageSrc = this.getFormInfo(
              formInfo,
              'EndPage_Image'
            );
            this.surveyFrontEndWording.title = this.beforeStart_Title;
            this.surveyFrontEndWording.content = (
              this.beforeStart_Content || ''
            ).replace(
              /{tspFormStart}/g,
              new Date(this.StartTime).toLocaleString()
            );
          } else {
            this.formImage = this.getFormInfo(formInfo, 'FormImage');

            this.surveyFrontEndWording.imageSrc = this.getFormInfo(
              formInfo,
              'EndPage_Image'
            );
            this.surveyFrontEndWording.title = this.afterEnd_Title;
            this.surveyFrontEndWording.content = (
              this.afterEnd_Content || ''
            ).replace(/{tspFormEnd}/g, new Date(this.EndTime).toLocaleString());
          }
        });
    },
    getStillHaveTotalSec() {
      this.stillHaveTotalSec = parseInt(
        (this.EndTime - new Date().getTime()) / 1000,
        10
      );
      if (this.EndTime === 0) {
        clearInterval(this.timer);
      }

      if (this.stillHaveTotalSec <= 0 && this.EndTime !== 0) {
        this.isOutTime = true;
        sessionStorage.removeItem('strFormReplyID');
        clearInterval(this.timer);
      }
    },
    getForm() {
      const params = {
        formID: this.formID
      };

      const { formReplyID } = this.$route.query;
      SurveyService.getSurvayTemplate(params).then((res) => {
        if (res.success) {
          const { formInfo } = res.data[0]; // 2020.09.15 api回傳值修改為list Adam
          if (res.data[0].ration === true && !formReplyID) {
            this.isSuccessSSO = false;
            this.isNeedDoSSO(formInfo, res.data[0]);
          } else {
            this.checkCanReply(formInfo);
          }
          this.placeHolder = this.getFormInfo(formInfo, 'PlaceHolder');
          this.submitForm = this.getFormInfo(formInfo, 'submitButtonWording');
          this.set({
            id: 'bgColor',
            value: this.getFormInfo(formInfo, 'bgColor')
          });
          this.set({
            id: 'themeColor',
            value: {
              '--theme-color': this.hexToRgbA(
                this.getFormInfo(formInfo, 'themeColor')
              )
            }
          });
          this.set({
            id: 'themeFontColor',
            value: this.getFormInfo(formInfo, 'themeFontColor')
          });
          this.set({
            id: 'bgFontColor',
            value: this.getFormInfo(formInfo, 'bgFontColor')
          });

          this.showCountDown = res.data[0].formLifeCycle
            && res.data[0].formLifeCycle > 0;

          this.callGetFormDone = true;
          // this.SurveyTemplateData = res.data;
          const tmpData = res.data[0];
          this.SurveyTemplateData = tmpData;
          // 塞Active值 做跳題
          this.SurveyTemplateData.formDetail.forEach((element) => {
            const data = element;
            this.$set(data, 'Active', true);
            // data.Active = true;
            this.$set(data, 'isMsutAlert', false);
            // data.isMsutAlert = false;
          });

          this.setFormData({
            id: 'surveyTemplateData',
            value: this.SurveyTemplateData
          });

          this.AllQustionCnt = this.SurveyTemplateData.formDetail.length;
        } else {
          this.$router.replace({ name: 'Error' });
        }
      });
    },
    getFormInfo(formInfo, id) {
      const haveTarget = formInfo.find((d) => d.formparam === id);
      if (haveTarget) {
        return haveTarget.formvalue;
      }
      return haveTarget;
    },
    getFormParams() {
      // const vm = this;
      const params = {
        formParamCode: ''
      };

      SurveyService.getFormParams(params).then((res) => {
        if (res.success) {
          let sys = '';
          sys = (
            navigator.language
            || navigator.userLanguage
            || navigator.browserLanguage
            || navigator.systemLanguage
          ).toLowerCase();

          let searchLanguage = '';

          switch (sys) {
            case 'zh-tw':
            case 'zh-cn':
              searchLanguage = sys;
              break;
            default:
              searchLanguage = 'en-us';
              break;
          }

          let id = '';
          id = this.addLangIdentifyID(res.data, 'MustAlertWording', id);
          id = this.addLangIdentifyID(res.data, 'MustOtherAlertWording', id);
          id = this.addLangIdentifyID(res.data, 'FormConutdown', id);
          id = this.addLangIdentifyID(res.data, 'TextOfOK', id);
          id = this.addLangIdentifyID(res.data, 'TextOfCancel', id);
          id = this.addLangIdentifyID(res.data, 'LeavePopupWording', id);
          id = this.addLangIdentifyID(res.data, 'BeforeStart_Title', id);
          id = this.addLangIdentifyID(res.data, 'BeforeStart_Content', id);
          this.beforeStart_ImageSrc = res.data.find(
            (x) => x.formParamCode === 'BeforeStart_ImageSrc'
          ).formParamValue;
          id = this.addLangIdentifyID(res.data, 'AfterEnd_Title', id);
          id = this.addLangIdentifyID(res.data, 'AfterEnd_Content', id);
          this.afterEnd_ImageSrc = res.data.find(
            (x) => x.formParamCode === 'AfterEnd_ImageSrc'
          ).formParamValue;

          this.getLanguage(id).then((LangRes) => {
            this.getForm();
            this.mustAlertWording = this.setInternationalWording(
              LangRes.data,
              res.data,
              searchLanguage,
              'MustAlertWording'
            );
            this.mustOtherAlertWording = this.setInternationalWording(
              LangRes.data,
              res.data,
              searchLanguage,
              'MustOtherAlertWording'
            );
            this.formCountdown = this.setInternationalWording(
              LangRes.data,
              res.data,
              searchLanguage,
              'FormConutdown'
            );
            this.textOfOK = this.setInternationalWording(
              LangRes.data,
              res.data,
              searchLanguage,
              'TextOfOK'
            );
            this.textOfCancel = this.setInternationalWording(
              LangRes.data,
              res.data,
              searchLanguage,
              'TextOfCancel'
            );
            this.content = this.setInternationalWording(
              LangRes.data,
              res.data,
              searchLanguage,
              'LeavePopupWording'
            );
            this.beforeStart_Title = this.setInternationalWording(
              LangRes.data,
              res.data,
              searchLanguage,
              'BeforeStart_Title'
            );
            this.beforeStart_Content = this.setInternationalWording(
              LangRes.data,
              res.data,
              searchLanguage,
              'BeforeStart_Content'
            );
            this.afterEnd_Title = this.setInternationalWording(
              LangRes.data,
              res.data,
              searchLanguage,
              'AfterEnd_Title'
            );
            this.afterEnd_Content = this.setInternationalWording(
              LangRes.data,
              res.data,
              searchLanguage,
              'AfterEnd_Content'
            );
          });
        } else {
          this.$router.replace({ name: 'Error' });
        }
      });
    },
    setInternationalWording(wordings, params, searchLanguage, id) {
      const haveLanguage = wordings.find(
        (x) => x.langCultureName === searchLanguage
      );
      if (haveLanguage && haveLanguage.langIdentifyIDAndDisplayName) {
        const haveWording = haveLanguage.langIdentifyIDAndDisplayName.find(
          (x) => x.langIdentifyID === this.addLangIdentifyID(params, id)
        );
        if (haveWording && haveWording.displayName) {
          return haveWording.displayName;
        }
        return '';
      }
      return '';
    },
    addLangIdentifyID(params, paramCode, id = '') {
      const haveValue = params.find((x) => x.formParamCode === paramCode);
      if (haveValue && haveValue.formParamValue) {
        if (id) {
          return `${id}|${haveValue.formParamValue}`;
        }
        return haveValue.formParamValue;
      }
      return id;
    },
    getLanguage(IDs) {
      // const vm = this;
      const params = {
        LangIdentifyIDs: IDs
      };

      return SurveyService.getLanguageWording(params).then(
        (LanRes) => {
          if (!LanRes.success) {
            this.$router.replace({ name: 'Error' });
          }
          return LanRes;
        }
      );
    },
    // hex -> Rgb
    hexToRgbA(sHex, alpha = 1) {
      const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      let sColor = sHex.toLowerCase();
      if (sColor && reg.test(sColor)) {
        if (sColor.length === 4) {
          let sColorNew = '#';
          for (let i = 1; i < 4; i += 1) {
            sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1));
          }
          sColor = sColorNew;
        }
        const sColorChange = [];
        for (let i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt(sColor.slice(i, i + 2), 16));
        }
        return `${sColorChange.join(',')},${alpha}`;
      }
      return sColor;
    },
    pad(num, n = 2) {
      // 補0
      let result = num.toString();
      let len = num.toString().length;

      for (len; len < n; len += 1) {
        result = `0${result}`;
      }

      if (len < n) {
        return num;
      }
      return result;
    },
    isiOS() {
      const u = navigator.userAgent;
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    realGoOut() {
      this.replyed = true;
      this.$router.push(this.goRoute);
    },
    isNeedDoSSO(formInfo, formData) {
      this.formCompany().then((res2) => {
        if (res2 && res2.success) {
          const params = {
            formID: this.formID,
            memberSourceID: res2.data[0].memberSourceId
          };

          let ssoLoginQueryString = '';

          if (formData.memberSourcePairNo) {
            ssoLoginQueryString = `membersourcepairno=${formData.memberSourcePairNo}`;
          } else {
            ssoLoginQueryString = new URLSearchParams({ companyid: res2.data[0].companyId, membersourceid: res2.data[0].memberSourceId }).toString();
          }

          const queryString = new URLSearchParams(params).toString();

          const redirectUrl = encodeURIComponent(`${window.location.origin}${publicPath}/index?${queryString}`);

          const ssoLoginUrl = `${SsoVueUrl}login?${ssoLoginQueryString}&redirect_url=${redirectUrl}`;

          const ACCESS_TOKEN_KEY = '_gateteway_t';
          const sessionStorageToken = sessionStorage.getItem(ACCESS_TOKEN_KEY);
          if (sessionStorageToken) {
            this.verifyAccessToken(ssoLoginUrl, sessionStorageToken, formInfo, this.formID);
          } else if (this.ssoCode) {
            // 判斷是否有帶 code 有 => 進行accessToken 驗證 驗證失敗則再做一次 sso / 沒有 => 做 sso 登入

            this.getAccessToken(this.ssoCode, res2.data[0].companyId, res2.data[0].memberSourceId)
              .then((res3) => {
                const { accessToken } = res3.data[0];
                // 驗證 accessToken
                sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
                this.verifyAccessToken(ssoLoginUrl, accessToken, formInfo, this.formID);
              })
              .catch(() => {
                // 跳轉至 SSO 登入頁
                window.location.href = ssoLoginUrl;
              });
          } else {
            // 跳轉至 SSO 登入頁
            window.location.href = ssoLoginUrl;
          }
        } else {
          this.isSuccessSSO = true;
          this.checkCanReply(formInfo);
        }
      })
        .catch(() => {
          this.isSuccessSSO = true;
          this.checkCanReply(formInfo);
        });
    },
    getAccessToken(code, companyId, memberSourceId) {
      const body = {
        companyId,
        memberSourceId,
        code
      };

      return ssoService.getDigest(companyId, memberSourceId, body)
        .then((res) => {
          const headers = { digest: res.data[0].digest };
          return ssoService.getAccessToken(body, headers);
        });
    },
    verifyAccessToken(path, accessToken, formInfo, formId) {
      ssoService.verifiyAccesstoken({ accessToken }).then((res) => {
        const ACCESS_TOKEN_KEY = '_gateteway_t';
        // 驗證 失敗 再導一次sso
        if (res.status !== '200') {
          sessionStorage.removeItem(ACCESS_TOKEN_KEY);
          window.location.href = path;
        } else {
          sessionStorage.setItem('code', this.ssoCode);
          sessionStorage.setItem('memberId', res.data[0].memberID);
          sessionStorage.setItem('memberAcntNo', res.data[0].memberID);

          this.goFormLinkUrl(formId, res.data[0].memberID);
        }
      })
        .catch(() => {
          const ACCESS_TOKEN_KEY = '_gateteway_t';
          sessionStorage.removeItem(ACCESS_TOKEN_KEY);
          // 失敗 再導一次sso
          window.location.href = path;
        });
    },
    goFormLinkUrl(formId, customerID) {
      const body = {
        formId,
        customerID: [customerID]
      };
      this.getFormLinkUrl(body).then((res2) => {
        this.isSuccessSSO = true;
        sessionStorage.formReplyID = res2.data[0].formLink[0].formReplyID;
        window.location.href = res2.data[0].formLink[0].url;
      });
    }
  },
  computed: {
    ...mapState('formSetting', [
      'bgColor',
      'themeColor',
      'bgFontColor',
      'themeFontColor'
    ]),
    Completepercentage() {
      return Math.round((this.AlreadyFillin / this.AllQustionCnt) * 100);
    },
    stillHaveSec() {
      return this.stillHaveTotalSec % 60;
    },
    stillHaveTotalMin() {
      return (this.stillHaveTotalSec - this.stillHaveSec) / 60;
    }
  },
  created() {
    this.replyed = false;
    this.getFormParams();
    this.set({
      id: 'formID',
      value: this.formID
    });
    sessionStorage.formID = this.formID;
  },
  mounted() {
    window.onbeforeunload = () => {
      if (!this.replyed) {
        return false;
      }
      return undefined;
    };
    if (this.isiOS()) {
      window.onpageshow = (e) => {
        if (
          e.persisted
          || (window.performance && window.performance.navigation.type === 2)
        ) {
          window.location.reload();
        }
      };
    }
  }
};
</script>

<style>
 img {max-width: 100%;}
</style>
